import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "#e8eaed"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M430.91-176Q479-176 512-208.93q33-32.94 33-81.07v-158h130v-94H499v158q-15-10-32.5-15t-35.27-5Q383-404 350-371.09q-33 32.9-33 81Q317-242 349.91-209q32.9 33 81 33ZM236-48q-43.73 0-74.86-31.14Q130-110.28 130-154v-652q0-43.72 31.14-74.86Q192.27-912 236-912h314l280 282v476q0 43.72-31.14 74.86T724-48H236Zm260-530v-228H236v652h488v-424H496ZM236-806v228-228 652-652Z" }, null, -1)
  ]))]))
}
export default { render: render }